var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['common-iconfont', 'common-iconfont-' + _vm.type ],style:({ 'fontSize': _vm.size + 'px', 'color': _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }